import { render, staticRenderFns } from "./SalesPendingSalesOrderTable.vue?vue&type=template&id=71e8eec0"
import script from "./SalesPendingSalesOrderTable.vue?vue&type=script&lang=ts"
export * from "./SalesPendingSalesOrderTable.vue?vue&type=script&lang=ts"
import style0 from "./SalesPendingSalesOrderTable.vue?vue&type=style&index=0&id=71e8eec0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports